// @flow
import { css } from 'styled-components';

const BREAKPOINTS = {
  MOBILE_SMALL: 320,
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  DESKTOP_LARGE: 1200,
  DESKTOP_HD: 1452,
};

const queries = {
  mobileSmall: `(max-width: ${BREAKPOINTS.MOBILE_SMALL}px)`,
  mobile: `(max-width: ${BREAKPOINTS.MOBILE}px)`,
  aboveMobile2: `(min-width: ${BREAKPOINTS.MOBILE}px)`,
  aboveMobile: `(min-width: ${BREAKPOINTS.TABLET}px)`,
  tabletSmall: `(min-width: ${BREAKPOINTS.MOBILE}px) and (max-width: ${BREAKPOINTS.TABLET}px)`,
  tablet: `(min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}px)`,
  belowDesktop: `(max-width: ${BREAKPOINTS.DESKTOP}px)`,
  belowLargeDesktop: `(max-width: ${BREAKPOINTS.DESKTOP_LARGE}px)`,
  midDesktop: `(min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP_LARGE}px)`,
  desktop: `(min-width: ${BREAKPOINTS.DESKTOP}px)`,
  aboveDesktop: `(min-width: ${BREAKPOINTS.DESKTOP_LARGE}px)`,
  desktopHd: `(min-width: ${BREAKPOINTS.DESKTOP_HD}px)`,
};

export const media = Object.keys(queries).reduce((acc, label) => {
  acc[label] = (...args: any) => css`
    && {
      @media ${queries[label]} {
        ${css(...args)};
      }
    }
  `;
  return acc;
}, {});

export const COMMON = {
  DESKTOP_SMALL_WIDTH: '996px',
  DESKTOP_BASE_WIDTH: '1060px',
  DESKTOP_MID_WIDTH: '1200px',
  DESKTOP_HD_WIDTH: '1452px',
  MOBILE_BROWSER_FOOTER_HEIGHT: '112px', // used to offset browser nav bars
  DESKTOP_HEADER_HEIGHT: '94px', // used to offset chat modal
  DG_DESKTOP_HEADER_HEIGHT: '90px',
  MOBILE_HEADER_HEIGHT: '140px',
};

export const toResponsivePath = (
  path: string,
  isMobile: boolean,
  ext?: string = 'png',
) => `${path}-${isMobile ? 'mobile' : 'desktop'}.${ext}`;
